import api from '../technique/api';

export const ImageBDL = () => ({
  getUtilisateurImage: (fileName: string) =>
    api.get(`auth/utilisateur/get-file/${fileName}`, {
      responseType: 'arraybuffer',
    }),
});
